import { render, staticRenderFns } from "./next_coaching.vue?vue&type=template&id=56b201a8"
import script from "./next_coaching.vue?vue&type=script&lang=js"
export * from "./next_coaching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports